import { sendToApi } from 'api/client'
import { DesignChannel } from 'components/NewFileModal/Types'
import { CompletedDesignActions } from 'types'

export interface DesignPreview {
  id: string
  url: string
  still?: string
  mime_type: string
}

export const DesignClient = {
  update: (almanacFileId: string, options: { title: string }) => {
    return sendToApi(`/almanac_files/${almanacFileId}`, {
      method: 'PUT',
      body: {
        ...options,
      },
    })
  },
  updateDesign: (
    id: string,
    options: {
      content?: any
      preview_url?: string
      completed_actions?: CompletedDesignActions
      blank_toast_dismissed?: boolean
      width?: number
      height?: number
      channel?: DesignChannel
    },
  ) => {
    return sendToApi<void>(`/almanac_files/${id}/design`, {
      method: 'PUT',
      body: {
        ...options,
      },
    })
  },
  destroy: (id: string) => {
    return sendToApi(`/almanac_files/${id}/design`, {
      method: 'DELETE',
    })
  },
  transferOwnership: (id: string, user_id: number) =>
    sendToApi<{}>(`/almanac_files/${id}/design/transfer`, {
      method: 'POST',
      body: {
        user_id,
      },
    }),
  updateCaptions: (id: string, captions: Array<string>, selectedCaptionId?: number) =>
    sendToApi<void>(`/almanac_files/${id}/design/captions`, {
      method: 'PUT',
      body: {
        captions,
        selected_caption_id: selectedCaptionId,
      },
    }),
}
